@if ((loadingState$ | async)?.isLoading) {
  <div class="loading-overlay">
    <div class="loading-content">
      <!-- Custom Logo Spinner -->
      <div class="logo-spinner">
        <img
          src="assets/images/logos/logo-squared.jpg"
          alt="Loading"
          class="spinner-logo"
        />
      </div>

      <!-- Loading message with animated dots -->
      <div class="loading-message">
        <p class="message-text">
          {{ (loadingState$ | async)?.message || "Loading..." }}
        </p>
        <div class="loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    </div>
  </div>
}
